import { FLA_CODE } from "./flaCatalog";

export function seedFactories() {
  return {
    fac_demo_1: {
      id: "fac_demo_1", flag: "🇲🇽",
      SETUP: { name: "Confecciones del Bajío S.A.", country: "México", city: "León, Guanajuato", brand: "PUMA, Nike", workers: "820", product: "Calzado deportivo", resp: "Laura Méndez · Gerente de Cumplimiento", date: "2026-05-12", period: "FY2026" },
      RATINGS: {
        "ER.1":"compliant","ER.4":"compliant","ER.5":"compliant","ER.14":"compliant","ER.17":"compliant","ER.18":"ue","ER.19":"compliant",
        "ND.1":"compliant","ND.2":"compliant","ND.5":"compliant","ND.7":"nc","ND.8":"ue",
        "HA.1":"compliant","HA.2":"compliant","HA.6":"compliant","HA.7":"ue",
        "F.1":"compliant","F.2":"compliant","F.6":"compliant","F.9":"compliant","F.10":"compliant",
        "CL.1":"compliant","CL.2":"compliant","CL.3":"compliant","CL.7":"compliant",
        "FOA.1":"compliant","FOA.2":"compliant","FOA.5":"compliant","FOA.7":"compliant",
        "HSE.1":"compliant","HSE.2":"compliant","HSE.5":"compliant","HSE.6":"nc","HSE.14":"compliant","HSE.18":"ue","HSE.23":"compliant","HSE.27":"compliant",
        "HOW.1":"compliant","HOW.2":"nc","HOW.3":"compliant","HOW.6":"compliant",
        "C.1":"compliant","C.2":"compliant","C.5":"compliant","C.7":"compliant","C.10":"compliant","C.13":"ue",
      },
      NOTES: {
        "ND.7": "Se halló un formato de ingreso que solicitaba estado civil y planes de embarazo. Retirado durante la visita; falta política formal.",
        "ND.8": "No se pudo corroborar la existencia de pausas de lactancia ni ajustes de jornada documentados para embarazadas.",
        "HA.7": "Sin registro de capacitación en prevención de acoso a supervisores en los últimos 24 meses.",
        "ER.18": "El sistema disciplinario existe pero no se evidenció proceso de apelación ni testigo de tercera parte.",
        "HSE.6": "Dos salidas de emergencia del 2° piso obstruidas con material. Plan de evacuación no publicado en área de corte.",
        "HSE.18": "EPP disponible pero sin registro individual de entrega firmado.",
        "HOW.2": "En picos de temporada (mar-abr) se registraron semanas de 64-68 h en línea de ensamble.",
        "C.13": "No hay análisis de brecha frente a necesidades básicas / living wage.",
      },
      CAPDATA: {
        "HSE.6": { root: "Falta de procedimiento de inspección periódica de rutas de evacuación.", action: "Despejar y señalizar salidas; publicar plan de evacuación en todas las áreas; inspección semanal documentada.", owner: "Coordinador de SST", due: "2026-06-30", status: "En progreso" },
        "HOW.2": { root: "Planificación de producción no contempla picos; horas extra forzadas para cumplir entregas.", action: "Revisar planificación con cliente; implementar registro de voluntariedad de HE; tope de 60 h/sem.", owner: "Gerente de Producción", due: "2026-07-15", status: "Abierta" },
      },
    },
    fac_demo_2: {
      id: "fac_demo_2", flag: "🇧🇷",
      SETUP: { name: "Malhas RVB Ltda · Unidade I", country: "Brasil", city: "Blumenau, SC", brand: "VF Corporation", workers: "430", product: "Tejido de punto / apparel", resp: "Carlos Henrique Vieira · Coord. SST", date: "2026-04-28", period: "Q2-2026" },
      RATINGS: {
        "ER.1":"compliant","ER.4":"ue","ER.5":"compliant","ER.14":"compliant","ER.17":"compliant","ER.18":"compliant","ER.19":"ue",
        "ND.1":"compliant","ND.2":"compliant","ND.5":"compliant","ND.7":"compliant","ND.8":"compliant",
        "HA.1":"compliant","HA.2":"compliant","HA.6":"ue","HA.7":"nc",
        "F.1":"compliant","F.2":"compliant","F.6":"compliant","F.9":"compliant","F.10":"compliant",
        "CL.1":"compliant","CL.2":"compliant","CL.3":"compliant","CL.7":"compliant",
        "FOA.1":"compliant","FOA.2":"compliant","FOA.5":"compliant","FOA.7":"compliant",
        "HSE.1":"compliant","HSE.2":"compliant","HSE.5":"compliant","HSE.6":"compliant","HSE.14":"compliant","HSE.18":"ue","HSE.23":"compliant","HSE.27":"nc",
        "HOW.1":"compliant","HOW.2":"compliant","HOW.3":"compliant","HOW.6":"ue",
        "C.1":"compliant","C.2":"compliant","C.5":"compliant","C.7":"compliant","C.10":"compliant","C.13":"compliant",
      },
      NOTES: {
        "ER.4": "El Código FLA no está publicado en portugués en todas las áreas comunes; pendiente verificar afiches.",
        "ER.19": "No se pudo corroborar archivo completo de documentación de cumplimiento disponible para assessors.",
        "HA.6": "Política de acoso sexual existe pero no hay evidencia de difusión a la planta.",
        "HA.7": "No hay registro de capacitación a supervisores sobre prevención de acoso en los últimos 24 meses.",
        "HSE.18": "EPP auditivo disponible pero sin registro de entrega individual firmado.",
        "HSE.27": "Efluentes de tintorería sin análisis fisicoquímico vigente; licencia ambiental en trámite de renovación.",
        "HOW.6": "Sistema de marcación coexiste con planillas manuales; riesgo de doble registro.",
      },
      CAPDATA: {
        "HSE.27": { root: "Renovación de licencia ambiental demorada; sin contrato vigente de laboratorio.", action: "Contratar análisis fisicoquímico de efluentes; completar renovación de licencia; monitoreo trimestral.", owner: "Gerência Ambiental", due: "2026-08-31", status: "Abierta" },
        "HA.7":   { root: "No existe plan anual de capacitación en prevención de acoso.", action: "Diseñar e impartir capacitación a 100% de supervisores; registrar asistencia; ciclo anual.", owner: "RH", due: "2026-07-31", status: "En progreso" },
      },
    },
    fac_demo_3: {
      id: "fac_demo_3", flag: "🇬🇹",
      SETUP: { name: "Omega Tex Guatemala", country: "Guatemala", city: "Villa Nueva", brand: "Ralph Lauren", workers: "1.150", product: "Camisería / apparel", resp: "María José Coj · Compliance Officer", date: "2026-06-02", period: "FY2026" },
      RATINGS: {
        "ER.1":"compliant","ER.4":"ue","ER.5":"compliant","ER.14":"compliant","ER.17":"compliant","ER.18":"nc","ER.19":"compliant",
        "ND.1":"compliant","ND.2":"compliant","ND.5":"compliant","ND.7":"compliant","ND.8":"compliant",
        "HA.1":"compliant","HA.2":"compliant","HA.6":"compliant","HA.7":"compliant",
        "F.1":"compliant","F.2":"compliant","F.6":"nc","F.9":"compliant","F.10":"compliant",
        "CL.1":"compliant","CL.2":"compliant","CL.3":"compliant","CL.7":"compliant",
        "FOA.1":"compliant","FOA.2":"ue","FOA.5":"compliant","FOA.7":"compliant",
        "HSE.1":"compliant","HSE.2":"compliant","HSE.5":"compliant","HSE.6":"compliant","HSE.14":"compliant","HSE.18":"compliant","HSE.23":"compliant","HSE.27":"compliant",
        "HOW.1":"compliant","HOW.2":"compliant","HOW.3":"compliant","HOW.6":"compliant",
        "C.1":"compliant","C.2":"compliant","C.5":"compliant","C.7":"compliant","C.10":"compliant","C.13":"compliant",
      },
      NOTES: {
        "ER.4":  "El reglamento interno no está disponible en idioma de trabajadores migrantes (población minoritaria).",
        "ER.18": "Se aplicaron descuentos salariales como medida disciplinaria por llegadas tarde, sin base legal ni disciplina progresiva.",
        "F.6":   "No se pudo corroborar que la agencia de reclutamiento no cobre honorarios a los trabajadores (riesgo Employer Pays).",
        "FOA.2": "Un trabajador reportó presión informal tras un intento de organización; caso bajo revisión.",
      },
      CAPDATA: {
        "ER.18": { root: "Reglamento disciplinario admite sanciones monetarias contrarias a la ley.", action: "Eliminar descuentos disciplinarios; reescribir reglamento con disciplina progresiva; reintegrar montos.", owner: "Asesoría Legal / RH", due: "2026-07-10", status: "Abierta" },
        "F.6":   { root: "Sin debida diligencia documentada sobre la agencia de reclutamiento.", action: "Auditar agencia; obtener declaración Employer Pays; reembolsar honorarios si se confirman.", owner: "Compliance Officer", due: "2026-09-15", status: "Abierta" },
      },
    },
  };
}

export function flaDefaultDB() {
  return { current: "fac_demo_1", factories: seedFactories() };
}

// ── Scoring ────────────────────────────────────────────────────────────────

export function flaElemScore(elem, ratings) {
  let c = 0, nc = 0, ue = 0, na = 0, answered = 0;
  elem.bm.forEach(b => {
    const r = ratings[b.c];
    if (r) { answered++; if (r === "compliant") c++; else if (r === "nc") nc++; else if (r === "ue") ue++; else na++; }
  });
  const applicable = c + nc + ue;
  const pct = applicable > 0 ? Math.round((c / applicable) * 100) : 0;
  let cls = "n";
  if (applicable > 0) { if (pct >= 90) cls = "g"; else if (pct >= 70) cls = "y"; else if (pct >= 50) cls = "o"; else cls = "r"; }
  return { c, nc, ue, na, answered, applicable, pct, done: answered === elem.bm.length, cls };
}

export function flaGlobalScore(ratings) {
  let c = 0, nc = 0, ue = 0, na = 0, answered = 0;
  FLA_CODE.forEach(e => e.bm.forEach(b => {
    const r = ratings[b.c];
    if (r) { answered++; if (r === "compliant") c++; else if (r === "nc") nc++; else if (r === "ue") ue++; else na++; }
  }));
  const applicable = c + nc + ue;
  return { c, nc, ue, na, answered, pending: 47 - answered, applicable, pct: applicable > 0 ? Math.round((c / applicable) * 100) : 0 };
}

export function flaGetGaps(ratings, notes) {
  const gaps = [];
  FLA_CODE.forEach(e => e.bm.forEach(b => {
    const r = ratings[b.c];
    if (r === "nc" || r === "ue") gaps.push({ elem: e, code: b.c, title: b.t, bench: b.b, status: r, note: (notes || {})[b.c] || "" });
  }));
  return gaps;
}

export function flaTabDot(elem, ratings) {
  const s = flaElemScore(elem, ratings);
  if (s.answered === 0) return "dn";
  if (s.nc > 0) return "dr";
  if (s.ue > 0) return "do";
  if (!s.done) return "dy";
  return "dg";
}

export function flaParseImport(raw) {
  const data = JSON.parse(raw);
  const db = data?.DB || data;
  if (!db || typeof db !== "object" || !db.factories || typeof db.factories !== "object" || Object.keys(db.factories).length === 0) {
    throw new Error("Formato inválido: no se encontraron fábricas en el archivo.");
  }
  const current = db.current && db.factories[db.current] ? db.current : Object.keys(db.factories)[0];
  return { current, factories: db.factories };
}

export function flaExportJSON(db) {
  const data = { meta: { tool: "Sustemia FLA", exported: new Date().toISOString() }, DB: db };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  const name = (Object.values(db.factories).find(f => f.id === db.current)?.SETUP?.name || "fabrica").replace(/[^a-z0-9]/gi, "_");
  a.download = `Sustemia_FLA_${name}_${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
}
